__turbopack_context__.v({
  "resourceKeyList": "resource-key-list-module-scss-module__PGrhRG__resourceKeyList",
  "resourceKeyListCheckmark": "resource-key-list-module-scss-module__PGrhRG__resourceKeyListCheckmark",
  "resourceKeyListItem": "resource-key-list-module-scss-module__PGrhRG__resourceKeyListItem",
});
